import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=4e8988cd&scoped=true&"
import script from "./Select.vue?vue&type=script&lang=ts&"
export * from "./Select.vue?vue&type=script&lang=ts&"
import style0 from "./Select.vue?vue&type=style&index=0&id=4e8988cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8988cd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsChevronDownIcon16px: require('/var/www/packages/theme/components/icons/chevron-down/ChevronDownIcon16px.vue').default,IconsChevronUpIcon16px: require('/var/www/packages/theme/components/icons/chevron-up/ChevronUpIcon16px.vue').default,IconsCheckmark24px: require('/var/www/packages/theme/components/icons/checkmark/Checkmark24px.vue').default})
